import { useEffect, useState } from 'react';

import CountdownTimer from '@klv/molecules/countdown-timer';
import { generateClassName } from '@klv/shared/utils/functions';
import { getEstTimestamp } from './utils/functions';

import * as s from './styles/countdown.module.css';

import type { ICountdownProps } from './types';

const Countdown = ({
  background,
  headline,
  titleSize,
  countdown,
  customPadding,
  ...props
}: ICountdownProps) => {

  const [hydrated, setHydrated] = useState(false);
  const [displayed, setDisplayed] = useState<boolean>(true);
  const targetDate = getEstTimestamp(countdown);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;

  const countdownClasses = generateClassName([
    s.countdown,
    s[background],
    displayed && s.displayed,
    !displayed && 'nonePaddingTop',
    !displayed && 'nonePaddingBottom',
    (displayed && customPadding?.customPaddingTop === 'small') && 'smallPaddingTop',
    (displayed && customPadding?.customPaddingTop === 'default') && 'defaultPaddingTop',
    (displayed && customPadding?.customPaddingTop === 'none') && 'nonePaddingTop',
    (displayed && customPadding?.customPaddingBottom === 'small') && 'smallPaddingBottom',
    (displayed && customPadding?.customPaddingBottom === 'default') && 'defaultPaddingBottom',
    (displayed && customPadding?.customPaddingBottom === 'none') && 'nonePaddingBottom',
  ]);
  
  return (
    <div
      className={countdownClasses}
      {...props}
    >
      <div className="grid">
        <div className={s.container}>
          {titleSize && headline && (
            <h2 className={generateClassName([s.headline, s[background], titleSize])}>{headline}</h2>
          )}
          <CountdownTimer color={background} targetDate={targetDate} setDisplayed={setDisplayed}/>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
